module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-14.b719633e.svg";